import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { postData } from "../../../utility/Utility";
import Swal from "sweetalert2";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

function HelpAndSupportList() {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchTickets = async (page = 1, status = "", startDate = "", endDate = "") => {
    setLoading(true);
    try {
      const response = await postData(`api/support/admin/tickets/list`, {
        page,
        limit: rowsPerPage,
        status: status || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined
      });

      if (response?.success) {
        if (response?.success) {
          setTickets(response.data);
          setTotalPages(response.pagination?.totalPages || 1);
          setCurrentPage(page - 1);
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to fetch tickets',
          text: response?.message || 'Failed to fetch tickets'
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error fetching tickets',
        text: 'Error fetching tickets'
      });
      console.error("Fetch tickets error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets(currentPage + 1, statusFilter, startDate, endDate);
  }, [currentPage, statusFilter, startDate, endDate, rowsPerPage]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(0);
    fetchTickets(1, statusFilter, startDate, endDate);
  };



  const handleStatusChange = async (ticket, newStatus) => {
    try {
      const response = await postData(`api/support/admin/tickets/update-status`, {
        ticketId: ticket._id,
        status: newStatus,
      });

      if (response?.success) {
        fetchTickets(currentPage + 1, statusFilter);
      } else {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: response?.message || `Failed to update status`,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: 'Error updating status',
        showConfirmButton: false,
        timer: 2000
      });
      console.error("Status change error:", error);
    }
  };

  return (
    <div className="content-page">
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Ticket Management</h4>
              <p className="fw-semibold my-2">Ticket List</p>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-center">
                      <div className="col-md-12 col-lg-3">
                        <label htmlFor="statusFilter" className="form-label">Status</label>
                        <select
                          className="form-select"
                          id="statusFilter"
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                        >
                          <option value="">All Status</option>
                          <option value="active">Active</option>
                          <option value="in_progress">In Progress</option>
                          <option value="resolved">Resolved</option>
                          <option value="pending">Pending</option>
                        </select>
                      </div>


                      <div className="col-md-12 col-lg-2">
                        <label htmlFor="rowsPerPage" className="form-label">Rows per page</label>
                        <select
                          className="form-select"
                          id="rowsPerPage"
                          value={rowsPerPage}
                          onChange={(e) => setRowsPerPage(Number(e.target.value))}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        </select>
                      </div>


                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped table-hover mb-0">
                        <thead>
                          <tr>
                            <th width="5%" className="text-center">S.No</th>
                            <th width="15%">Ticket Title</th>
                            <th width="15%">User</th>
                            <th width="10%">Category</th>
                            <th width="10%">Status</th>
                            <th width="10%">Ticket Created On</th>
                            <th width="10%" className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tickets.length > 0 ? (
                            tickets.map((ticket, index) => (
                              <tr key={ticket._id}>
                                <td className="align-middle text-center">{index + 1 + currentPage * rowsPerPage}</td>
                                <td className="align-middle text-truncate" style={{ maxWidth: '200px' }} title={ticket.title}>
                                  {ticket.title}
                                </td>
                                <td className="align-middle">{ticket.userId?.fullName}  
                                <br />
                                {ticket.userId?.email || ticket.userId?.phone || ticket.userId?.username ||"Not Available"}
                                
                                </td>
                                <td className="align-middle">{ticket.category}</td>
                                <td className="align-middle">
                                  <span className={`badge text-capitalize bg-${ticket.status === 'active' ? 'success' :
                                    ticket.status === 'in_progress' ? 'info' :
                                      ticket.status === 'resolved' ? 'primary' : 'warning'}`}>
                                    {ticket.status.replace('_', ' ')}
                                  </span>
                                </td>
                                <td className="align-middle">
                                  {new Date(ticket.createdAt).toLocaleDateString()}
                                </td>
                                <td className="align-middle text-center">
                                  <div className="d-flex gap-2 justify-content-center">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => navigate(`/chat-reply-by-admin`, { state: { ticketData: ticket } })}
                                      title="View Details"
                                    >
                                      <i className="mdi mdi-eye"></i>
                                    </button>
                                    <select
                                      className="form-select form-select-sm"
                                      style={{ width: 'auto' }}
                                      value={ticket.status}
                                      onChange={(e) => handleStatusChange(ticket, e.target.value)}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <option value="active">Active</option>
                                      <option value="in_progress">In Progress</option>
                                      <option value="resolved">Resolved</option>
                                      <option value="pending">Pending</option>
                                    </select>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-4">
                                No tickets found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {totalPages > 1 && (
                        <ReactPaginate
                          previousLabel={<i className="mdi mdi-chevron-left"></i>}
                          nextLabel={<i className="mdi mdi-chevron-right"></i>}
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={totalPages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName="pagination pagination-rounded justify-content-end mt-3"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          activeClassName="active"
                          forcePage={currentPage}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpAndSupportList;